import styled from "styled-components";

const BackToTopContainer = styled.div`
    position: fixed;
    right: 1rem;
    bottom: 1rem;
    border: 1px solid var(--green);
    border-radius: 50%;
    height: 2rem;
    width: 2rem;
    box-sizing: content-box;
    transition-duration: .3s;
    z-index: 400;
    backdrop-filter: blur(3px);

    &:hover {
        transform: translateY(-0.25rem);
        background-color: var(--green-tint);
    }

    svg {
        height: 2rem;
        width: 2rem;
        fill: var(--green);
    }
`

export default function BackToTop(props) {
    return (
        <BackToTopContainer>
            <a href="#main">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="injected-svg" datasrc="https://static.elfsight.com/icons/app-back-to-top-arrow-2.svg"><path d="M15.47 14.328a.615.615 0 0 0 .853 0 .577.577 0 0 0 0-.832l-3.896-3.824a.615.615 0 0 0-.854 0l-3.896 3.824a.578.578 0 0 0 0 .832.615.615 0 0 0 .853 0L12 10.92l3.47 3.408z"></path></svg>
            </a>
        </BackToTopContainer>
    );
}
